module.exports = __webpack_public_path__ + "img/checkmark-circle-outline.f86654cd.svg";